import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import Login from './sections/login/Login';
import Legal from './sections/legal/Legal';
import NotFound from './sections/not_found/NotFound';
import Landing from './sections/landing/Landing';
import Developer from './sections/secured/developer/Developer';
import Dashboard from './sections/secured/dashboard/Dashboard';
import routeLocations from './utility/route-locations';
import ViaEntryRoute from './components/routes/ViaEntryRoute';
import Configure from './sections/secured/configure/Configure';
import RegistrationPage from './sections/login/registration/RegistrationPage';
import Inspection from './sections/secured/inspection/InspectionPage';
import VerifyEmail from './sections/secured/verify-email/VerifyEmail';
import ResetPassword from './sections/reset-password/ResetPassword';
import SetPassword from './sections/reset-password/SetPassword';
import MyDetails from './sections/secured/my-details/MyDetails';
import ChangeEmail from './sections/change-email/ChangeEmail';
import ForgotPassword from './sections/login/forgot-password/ForgotPassword';
import InspectionView from './sections/secured/inspection/InspectionView';
import AdminConsole from './sections/secured/bynx/AdminConsole';
import ViewImage from './images/ViewImage';
import PurchaseCredits from './sections/secured/purchase/PurchaseCredits';
import PurchaseHistory from './sections/secured/purchase/PurchaseHistory';
import EarlyProspect from './sections/prospect/EarlyProspect';
import CreditSummary from './sections/secured/purchase/CreditSummary';
import CreditHistory from './sections/secured/purchase/CreditHistory';
import ClientError from './sections/client-error/ClientError';
import InspectionsList from './sections/secured/inspections/InspectionsList';
import ContactUs from './sections/secured/support/ContactUs';
import VehicleExcelReader from './sections/secured/developer/utils/VehicleExcelReader';
import ContactUsExternal from "./sections/external/ContactUsExternal";
import AccountDeletionExternal from "./sections/external/AccountDeletionExternal";


/*
  Contains all the main routes for the application. (e.g. /configuration)
  Any sub route should be handled within the component that the main route renders.
  (e.g. /configuration/users should be handled in the Configuration component)

  IMPORTANT NOTE:
  Routes that are public can use the 'noAuth' prop.
  Conversely any route that requires authentication should not have this prop.
*/
export default function Routes() {
  return (
    <Switch>
      {process.env.NODE_ENV === 'development' && <ViaEntryRoute titleKey="developer" path={routeLocations.developer} component={Developer} />}
      <ViaEntryRoute exact path={`${routeLocations.images}/:file`} noAuth component={ViewImage} />
      <ViaEntryRoute titleKey="login" path={routeLocations.landing} exact noAuth><Redirect to={routeLocations.login} /></ViaEntryRoute>
      <ViaEntryRoute titleKey="platformTitle" exact path={routeLocations.landing} noAuth component={Landing} />
      <ViaEntryRoute titleKey="login" path={routeLocations.login} noAuth component={Login} className="mark-bg" />
      <ViaEntryRoute titleKey="signUp" path={routeLocations.signUp} noAuth component={RegistrationPage} className="mark-bg" />
      <ViaEntryRoute titleKey="legalDocuments" path={routeLocations.legal} noAuth component={Legal} showFooter={false} />
      <ViaEntryRoute titleKey="home" path={routeLocations.dashboard} component={Dashboard} />
      <ViaEntryRoute titleKey="purchaseCredits" path={routeLocations.purchaseCredits} component={PurchaseCredits} />
      <ViaEntryRoute titleKey="configure" path={routeLocations.configure} component={Configure} />
      <ViaEntryRoute titleKey="inspections" path={`${routeLocations.inspectionList}/:reason`} component={InspectionsList} />
      <ViaEntryRoute titleKey="inspections" path={routeLocations.inspectionList} component={InspectionsList} />
      <ViaEntryRoute titleKey="inspection" path={`${routeLocations.inspection}/:id`} component={Inspection} />
      <ViaEntryRoute titleKey="viewInspection" path={`${routeLocations.inspectionView}/:key`} noAuth showFooter={false} component={InspectionView} />
      <ViaEntryRoute titleKey="title.verify-email" path={routeLocations.verifyEmail} component={VerifyEmail} />
      <ViaEntryRoute titleKey="setPassword" path={routeLocations.resetPassword} noAuth component={ResetPassword} className="mark-bg" />
      <ViaEntryRoute titleKey="setPassword" path={routeLocations.setPassword} noAuth component={SetPassword} className="mark-bg" />
      <ViaEntryRoute titleKey="myDetails" path={routeLocations.myDetails} component={MyDetails} />
      <ViaEntryRoute titleKey="title.change-email" path={routeLocations.changeEmail} noAuth component={ChangeEmail} className="mark-bg" />
      <ViaEntryRoute titleKey="forgotPassword" path={routeLocations.forgotPassword} noAuth component={ForgotPassword} className="mark-bg" />
      <ViaEntryRoute titleKey="adminConsole" path={routeLocations.adminConsole} component={AdminConsole} />
      <ViaEntryRoute titleKey="purchaseHistory" path={routeLocations.purchaseHistory} component={PurchaseHistory} />
      <ViaEntryRoute titleKey="creditUtilisation" path={`${routeLocations.creditUsage}/:id`} component={CreditHistory} />
      <ViaEntryRoute titleKey="creditUtilisation" path={routeLocations.creditUsage} component={CreditSummary} />
      <ViaEntryRoute titleKey="contactUs" path={`${routeLocations.contactUs}/:ticketType`} component={ContactUs} />
      <ViaEntryRoute titleKey="contactUs" path={routeLocations.contactUs} component={ContactUs} />
      <ViaEntryRoute titleKey="contactUs" path={routeLocations.contactUsExternal} noAuth component={ContactUsExternal} />
      <ViaEntryRoute titleKey="accountDeletionTitle" path={routeLocations.accountDeleteExternal} noAuth component={AccountDeletionExternal} />
      <ViaEntryRoute titleKey="short" noAuth path={routeLocations.earlyProspect} component={EarlyProspect} className="mark-bg" />
      <ViaEntryRoute exact path={routeLocations.vehicleMulti} component={VehicleExcelReader} />
      <ViaEntryRoute titleKey="title.something-gone-wrong" noAuth path={routeLocations.clientError} component={ClientError} className="mark-bg" />
      <ViaEntryRoute titleKey="notFound" noAuth path={routeLocations.notFound} component={NotFound} className="mark-bg" />
      <ViaEntryRoute titleKey="notFound" noAuth component={NotFound} className="mark-bg" />
    </Switch>
  );
}
